<template lang="pug">
v-form(ref="form-basic-data" lazy-validation @submit.prevent="() => {}")
  v-row.mt-6
    v-col.pb-0(cols="12" sm="6"): v-text-field(
      v-model="form.name"
      label="Titel der Beratung"
      outlined
      :rules="[ rules.required ]"
    )

    v-col.pb-0(cols="12" sm="6"): v-select(
      v-model="form.template_id"
      label="Version"
      outlined
      :items="templates"
      item-text="name"
      item-value="id"
      :rules="[ rules.required ]"
      :disabled="!isCreation"
    )

    v-col.pb-0(cols="12" sm="6"): v-textarea(
      v-model="form.description"
      label="Beschreibung"
      outlined
    )

    v-col.pb-0(cols="12" sm="6"): v-select(
      v-model="form.payment_frequency"
      label="Zahlungsweise"
      outlined
      :items="payments"
      :rules="[ rules.required ]"
    )

    v-col.pb-0(cols="12" sm="6"): v-textarea(
      v-model="form.contact_data"
      label="Absender (Druckansicht)"
      v-if="!isCreation"
      outlined
    )

    v-col.pb-0(cols="12"): v-btn(cols="6" block color="primary" @click="onSave") Speichern
</template>

<script>
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import urls from '../../../../router/urls'
import FormMixin from '@/mixins/form'

@Component({
  mixins: [
    FormMixin,
  ]
})

export default class BasicData extends Vue {
  @Prop({ type: Object | null, default: null }) currentLight
  @Prop({ type: Boolean, default: false }) isCreation

  form = {
    template_id: this.currentLight ? this.currentLight.template_id : null,
    name: this.currentLight ? this.currentLight.name : '',
    description: this.currentLight ? this.currentLight.description : '',
    payment_frequency: this.currentLight ? this.currentLight.payment_frequency : 'Monatlich',
    contact_data: this.currentLight ? this.currentLight.contact_data : '',
  }

  templates = []
  payments = ['Monatlich', 'Jährlich']

  @Watch('currentLight')
  onCurrentLightChange () {
    if (this.currentLight) {
      this.form.description = this.currentLight.description
      this.form.name = this.currentLight.name
      this.form.payment_frequency = this.currentLight.payment_frequency
      this.form.template_id = this.templates.find(item => item.version === this.currentLight.version)?.id
      this.form.contact_data = this.currentLight.contact_data
    }
  }

  mounted () {
    if (this.currentLight) {
      this.form.description = this.currentLight.description
      this.form.name = this.currentLight.name
    }
    this.$axios
      .get(urls.ConsultationLightList(), { templates: true })
      .then(res => {
        this.templates = res.data
        if (res.data && this.isCreation) {
          this.form.template_id = this.templates[0].id
        } else if (res.data && !this.isCreation) {
          this.form.template_id = this.templates.find(item => item.version === this.currentLight?.version)?.id
        }
      })
    if (!this.isCreation) {
      this.$emit('updateLight')
    }
  }

  onSave () {
    if (!this.isFormValid('form-basic-data')) return
    if (this.isCreation) {
      this.$axios
        .post(urls.ConsultationLightCreate(), this.form)
        .then(res => {
          this.$toast.success('Daten gespeichert', 'Speichern')
          this.$emit('creation', res.data)
          this.$router.push({ name: 'rimas-light-edit', params: { id: res.data.id } })
        })
    } else {
      this.$axios
        .post(urls.ConsultationLightUpdate(), {
          id: this.currentLight.id,
          ...this.form })
        .then(res => {
          this.$toast.success('Daten gespeichert', 'Speichern')
        })
    }
  }
}
</script>
